import { BACKEND_AI_AGENT_URL } from "./../../../../config/variables";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";

const BACKEND_REPORTS_URL = `${BACKEND_AI_AGENT_URL}/ai-generated-token-report`;

export const fetchReport = async (projectId: string) => {
  if (!projectId) throw new Error("Project ID is required");

  try {
    const url = `${BACKEND_REPORTS_URL}?projectId=${encodeURIComponent(projectId)}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Failed to fetch AI report:", error);
    throw error;
  }
};

export const useFetchReport = (projectId?: string) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!projectId) return;

    const getReport = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const reportData = await fetchReport(projectId);
        setData(reportData);
      } catch (err: any) {
        setError(err.message);
        enqueueSnackbar(`Failed to fetch AI report: ${err.message}`, {
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    getReport();
  }, [projectId, enqueueSnackbar]);

  return {
    data,
    isLoading,
    error,
    refetch: () => {
      if (!projectId) return;
      return fetchReport(projectId).then(setData).catch(setError);
    },
  };
};
